let container = null;

const icons = {
  success: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
  error: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
  info: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
};

const styles = {
  success: { bg: '#f0fdf4', border: '#bbf7d0', color: '#15803d' },
  error: { bg: '#fef2f2', border: '#fecaca', color: '#dc2626' },
  info: { bg: '#eff6ff', border: '#bfdbfe', color: '#1d4ed8' },
};

function getContainer() {
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    container.style.cssText =
      'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;gap:8px;pointer-events:none;align-items:center;';
    document.body.appendChild(container);
  }
  return container;
}

function showToast(message, type = 'info') {
  const toastContainer = getContainer();
  const s = styles[type] || styles.info;

  const toast = document.createElement('div');
  toast.style.cssText = `
    pointer-events:auto;
    padding:12px 16px;
    border-radius:8px;
    display:flex;
    align-items:center;
    gap:8px;
    font-size:14px;
    font-family:system-ui,-apple-system,sans-serif;
    box-shadow:0 4px 12px rgba(0,0,0,0.15);
    transform:translateX(120%);
    transition:transform 0.3s ease,opacity 0.3s ease;
    opacity:0;
    max-width:400px;
    background:${s.bg};
    border:1px solid ${s.border};
    color:${s.color};
  `;
  toast.innerHTML = `${icons[type] || icons.info}<span>${message}</span>`;

  toastContainer.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.transform = 'translateY(0)';
    toast.style.opacity = '1';
  });

  setTimeout(() => {
    toast.style.transform = 'translateY(20px)';
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

export { showToast };
